import { Component, Input, OnChanges, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { ImageSlideComponent } from '@app/shared/components/image-slide/image-slide.component';
import { ApplicationService } from '@app/core/services/application/application.service';
import { faUserMd } from '@fortawesome/free-solid-svg-icons';
import { ModalController } from '@ionic/angular';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ImgPipe } from '@app/shared/pipes/img/img.pipe';
import { ApplicationEnrolledChecklistComponent } from '../application-enrolled-checklist/application-enrolled-checklist.component';
import { GeneralDocumentsComponent } from '@app/modules/document/components/document-general/general-documents.component';
import { ApplicationReviewComponent } from '../application-review/application-review.component';
import { PipesComponentsModule } from '@app/shared/pipes/pipes.modules';

@Component({
    selector: 'app-enrolled',
    templateUrl: './application-enrolled.component.html',
    styleUrls: ['./application-enrolled.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        IonicModule,
        FontAwesomeModule,
        ImgPipe,
        ApplicationEnrolledChecklistComponent,
        GeneralDocumentsComponent,
        ApplicationReviewComponent,
    PipesComponentsModule,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ApplicationEnrolledComponent implements OnChanges {
    @Input() status: any;

    faUserMd = faUserMd;

    sliderOpts = {
        initialSlide: 0,
        speed: 400,
        scrollbar: true,
        slidesPerView: 1,
        centeredSlides: true,
    };

    reviewType: any;

    images = [];

    showMidRotationReview = false;
    // boolean to prompt the user to submit the mid rotation review
    promptForMidRotationReview = false;

    subscribe: any;
    showChecklist = true;
    showDocuments = false;

    constructor(private modalCtrl: ModalController, private applicationService: ApplicationService) {}

    ngOnChanges() {
        console.log('ENROLLED COMPONENT! ', this.status);
        if (this.status) {
            // user will always submit a mid rotation review from this page.
            this.reviewType = 'mid';
            this.applicationService.promptForMidRotationReview(this.status.application.id).subscribe((response: any) => {
                this.promptForMidRotationReview = response.promptMidRotationReview;
            });

            if (this.status.application.program.image.length > 0) {
                this.status.application.program.image.forEach((image) => {
                    const arr = [];
                    if (image.size === 'md') {
                        arr.push(image);
                        this.images.push(arr);
                    }
                });
            }
        }
    }

    submitMidRotationReview() {
        this.showMidRotationReview = true;
    }

    segmentChanged(ev: any) {
        this.showChecklist = ev.detail.value === 'checklist' ? true : false;
        this.showDocuments = ev.detail.value === 'documents' ? true : false;
    }

    openPreview = (img: any, i: number) => {
        this.modalCtrl
            .create({
                component: ImageSlideComponent,
                cssClass: 'image-slider-modal',
                componentProps: {
                    image: img,
                    index: i,
                    program: this.status.user.application.program,
                },
            })
            .then((modal) => {
                modal.present();
            });
    };

    OnDestroy() {
        // console.log('on destorrryy');
    }

    ionViewWillLeave() {
        // console.log('on destorrryy');
    }

    ionViewDidLeave() {
        // console.log('on destroy');
    }
}
